<template>
    <!--  -->
    <b-container fluid>
        <b-row v-if="!venues.length">
            <b-col>
                <b-alert show variant="warning">
                    <h4>Su perfil no esta configurado adecuadamente. Por favor comuniquese con el administrador.</h4>
                </b-alert>
            </b-col>
        </b-row>
        <b-row v-else align-h="center">
            <b-col cols="4">
                <b-row v-for="venue in venues" :key="venue.id">
                    <b-col>
                        <b-btn variant="primary">{{ venue.name }}</b-btn>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import * as mutations from '@store/_mutations'
import { mapMutations } from 'vuex'
export default {
    data: () => ({
        //
        venues: [],
    }),
    computed: {
        //
    },
    methods: {
        ...mapMutations({
            setCurrentVenue: mutations.SET_CURRENT_VENUE,
            setCurrentPerson: mutations.SET_CURRENT_PERSON,
            setCurrentUnit: mutations.SET_CURRENT_UNIT,
        }),
        async loadVenues() {
            const { data } = await this.$repo.get(`users/${this.currentUser.id}/venues`, {
                with: 'modules',
            })
            if (data.length === 1) {
                return this.setVenue(data[0])
            }
            this.venues = data
        },
        setVenue(venue) {
            this.setCurrentUnit(venue.unit)
            this.setCurrentVenue(venue)
            // set person from user for venue
            return this.next()
        },
        next() {
            return this.$router.push({
                name: this.currentProfile.default_screen,
            })
        },
    },
    mounted() {
        this.loadVenues()
    },
}
</script>
